<template>
  <i
    :class="classes"
    aria-hidden="true"
  ></i>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface FaIconProps {
  name: string;
  iconStyle?: 'solid' | 'regular' | 'light' | 'thin';
  iconType?: 'brands';
  iconSize?: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  iconClass?: string;
}

const props = withDefaults(defineProps<FaIconProps>(), {
  iconStyle: 'solid',
  iconType: undefined,
  iconSize: 'md',
  iconClass: undefined
})

const styleMap: Record<string, string> = {
  solid: 'fa-solid',
  regular: 'fa-regular',
  light: 'fa-light',
  thin: 'fa-thin'
}

const typeMap: Record<string, string> = {
  brands: 'fa-brands'
}

const styleClass = computed(() => styleMap[props.iconStyle])
const typeClass = computed(() => props.iconType ? typeMap[props.iconType] : '')
const sizeClass = computed(() => (props.iconSize !== 'md' && props.iconSize) ? `fa-${props.iconSize}` : '')
const customClass = computed(() => props.iconClass || '')
const classes = computed(() => `${styleClass.value} fa-${props.name} ${typeClass.value} ${sizeClass.value} ${customClass.value} leading-none`.trim())
</script>
